<template>
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
		<path
			fill="#949DAF"
			fill-rule="evenodd"
			d="M15.247 6.851a1.2 1.2 0 0 1 0 1.698L11.296 12.5l3.951 3.951a1.2 1.2 0 1 1-1.697 1.697l-4.8-4.8a1.2 1.2 0 0 1 0-1.697l4.8-4.8a1.2 1.2 0 0 1 1.697 0Z"
			clip-rule="evenodd"
		/>
	</svg>
</template>
